import { fabricConstants } from "../../constants";

export function fabrics(state = {}, action) {
  switch (action.type) {
    // get all
    case fabricConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case fabricConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case fabricConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case fabricConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case fabricConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case fabricConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case fabricConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case fabricConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case fabricConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case fabricConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case fabricConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case fabricConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case fabricConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
